import React from 'react'
import { Button } from '@deal/components'
import { OrderMessageFragment, DismissOrderMessageComponent } from '#src/generated/graphql'
import styles from './styles.css'

interface Props {
  messages: OrderMessageFragment[]
}

const CartAlerts: React.SFC<Props> = ({ messages }) => {
  return (
    <div className={styles.messageContainer}>
      {messages.map((message, idx) => (
        <div key={idx} className={message.dismissible ? styles.dismissible : styles.nonDismissible}>
          {message.message}
        </div>
      ))}
      {messages.length > 0 && <DismissMessages />}
    </div>
  )
}

const DismissMessages: React.SFC<{}> = () => (
  <DismissOrderMessageComponent>
    {dismissMessages => (
      <Button onClick={() => dismissMessages()} variant="link" size="xsmall">
        Dismiss
      </Button>
    )}
  </DismissOrderMessageComponent>
)

export default CartAlerts
